<template>

    <section class="pop" v-if="triggered">
        <div class="container">
            <div class="columns">
                <div class="column is-6 is-offset-3">
                    <div class="pop-content">
                        <div>
                            <span class="pop-close" @click="triggeredFalse">
                                <svg viewBox="0 0 26 26" fill="none" role="img" class="icon fill-current">
                                <path d="M8.28596 6.51819C7.7978 6.03003 7.00634 6.03003 6.51819 6.51819C6.03003 7.00634 6.03003 7.7978 6.51819 8.28596L11.2322 13L6.51819 17.714C6.03003 18.2022 6.03003 18.9937 6.51819 19.4818C7.00634 19.97 7.7978 19.97 8.28596 19.4818L13 14.7678L17.714 19.4818C18.2022 19.97 18.9937 19.97 19.4818 19.4818C19.97 18.9937 19.97 18.2022 19.4818 17.714L14.7678 13L19.4818 8.28596C19.97 7.7978 19.97 7.00634 19.4818 6.51819C18.9937 6.03003 18.2022 6.03003 17.714 6.51819L13 11.2322L8.28596 6.51819Z" fill="currentColor"></path>
                                </svg>
                            </span>
                            <h1 v-if="title" class="mt-5">{{ title }}</h1>
                            <div v-if="shortDescription" v-html="shortDescription" class="short-description"></div>
                            <div v-if="longDescription" v-html="longDescription" class="long-description"></div>
                            <iframe v-if="video" class="mt-6" width="100%" height="320" v-bind:src="video" 
                                frameborder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                allowfullscreen>
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
    export default {
        name: "Pop",
        props: ['triggered', 'title', 'year', 'shortDescription', 'longDescription', 'video' ],
        data() {
            return {
                isActive: this.$route.path
            }
        },
        mounted() {
            
        },
        methods: {
            triggeredFalse() {
                this.$emit('popClose', 'false');
            }
        }
    }
</script>
